import { createFileRoute } from "@tanstack/react-router";

import { PraxaAutomationDetail } from "../components/praxa/PraxaAutomationCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/automations/$automationId")({
  component: PraxaAutomationDetailRoute,
});

function PraxaAutomationDetailRoute() {
  const { workspaceId, automationId } = Route.useParams();
  return (
    <PraxaAutomationDetail
      automationId={automationId}
      view="automations"
      workspaceId={workspaceId}
    />
  );
}
